import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap from npm
import '@fortawesome/fontawesome-free/css/all.min.css'; // FontAwesome from npm
import './styles/themify-icons.css'; // Local custom styles
import './styles/flaticon-set.css';
import './styles/magnific-popup.css';
import './styles/owl.carousel.min.css';
import './styles/owl.theme.default.min.css';
import './styles/animate.css';
import './styles/bootsnav.css';
import './styles/style.css';  // Your main custom styles
import './styles/responsive.css';  // Responsive styles



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
